import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KDDatHang, KDDatHangChiTiet, DongYYCXNModel, DeXuatKHGHMoiNModel, ThongTinXacNhanModel, ThongTinXacNhanCTModel, HistoriesForecastChangeParam } from '../kd-dat-hang-model/kd-dat-hang.model';
const API_ROOT_URL = environment.ApiRoot + '/kddathang';
const API_ROOT_IMPORT_AND_TEMPLATE_PO = environment.ApiRoot + '/purchaseorder';
const API_EXPORT_URL = environment.ApiExport;

@Injectable()
export class KDDatHangService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		console.log(queryParams.filterGroup);
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DatHang_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDataForecastById(idHH: number, model: string): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/Forecast_ListById?IdHH=${idHH}&model=${model}`;
		return this.http.get<any>(url, { headers: httpHeaders });
	}

	getDataDG(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/YeuCauDuyetGia_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataLS(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/LS_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	insertOrder(item: KDDatHang): Observable<any> {
		item.Cts.forEach(x => {
			delete x.ListForecast;
			delete x.filteredListForecast;
		})
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/DatHang_Insert', item, { headers: httpHeaders });
	}
	ThayDoiForeCast(item: HistoriesForecastChangeParam): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/forecast_change', item, { headers: httpHeaders });
	}

	editOrder(item: KDDatHang): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KDDatHang>(API_ROOT_URL + '/DatHang_Update', item, { headers: httpHeaders });
	}

	detailOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const param = new HttpParams().set("Id", item.toString());
		return this.http.get<KDDatHang>(API_ROOT_URL + `/DatHang_Detail`, {
			headers: httpHeaders,
			params: param
		});
	}

	deleteOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const param = new HttpParams().set("Id", item.toString());
		return this.http.get<KDDatHang>(API_ROOT_URL + `/DatHang_Delete`, {
			headers: httpHeaders,
			params: param
		});
	}

	cancelOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const param = new HttpParams().set("Id", item.toString());
		return this.http.get<KDDatHang>(API_ROOT_URL + `/DatHang_Cancel`, {
			headers: httpHeaders,
			params: param
		});
	}

	acceptOrder(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/DatHang_Accept', item, { headers: httpHeaders });
	}

	confirmOrder(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/DatHang_Confirm', item, { headers: httpHeaders });
	}

	completeOrder(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/DatHang_Complete', item, { headers: httpHeaders });
	}
	DatHang_Dong(item: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/DatHang_Dong', item, { headers: httpHeaders });
	}

	dropdown(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KDDatHang>(API_ROOT_URL + `/YeuCauDuyetGia_Lite`, {
			headers: httpHeaders,
		});
	}
	ListHH(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KDDatHang>(API_ROOT_URL + `/ListHH`, {
			headers: httpHeaders,
		});
	}
	getThongTinXacNhan(IdDH: number, IdCt: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("IdDH", IdDH.toString()).set("IdCt", IdCt.toString())
		return this.http.get<ThongTinXacNhanModel>(API_ROOT_URL + `/ThongTinXacNhanGiaoHangLite`, {
			headers: httpHeaders,
			params: params
		});
	}

	lichSuThongTinXacNhan(IdDH: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("IdDH", IdDH.toString())
		return this.http.get<ThongTinXacNhanModel>(API_ROOT_URL + `/LichSuThongTinXacNhan`, {
			headers: httpHeaders,
			params: params
		});
	}

	xacNhanThongTinInsert(item: ThongTinXacNhanModel[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/XacNhanThongTin_Insert', item, { headers: httpHeaders });
	}

	getConfigDefaultCurrency(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/getConfigDefaultTienTe', { headers: httpHeaders });
	}

	getTonKhoHangHoa_ById(idHH: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("idHH", idHH.toString())
		return this.http.get<ThongTinXacNhanModel>(API_ROOT_URL + `/GetTonKhoHangHoa_ById`, {
			headers: httpHeaders,
			params: params
		});
	}

	xacNhanThongTinAll(IdDH: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/XacNhanThongTin_Multi', IdDH, { headers: httpHeaders });
	}

	xacNhanThongTinInsertFC(item: ThongTinXacNhanModel[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/XacNhanThongTin_InsertFC', item, { headers: httpHeaders });
	}

	downloadPriceEvidenceFiles(id: number): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("id", id.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/DownloadPriceEvidenceFiles', {
			headers: httpHeaders,
			params: httpParams,
			responseType: 'blob' as 'json'
		});
	}
	saveCustomerPurchaseOrder(data): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/update_customer_purchase_order', data, { headers: httpHeaders });
	}

	acceptForecastDeliveryRequest(item: ThongTinXacNhanCTModel[]): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/accept_forecast_delivery_request', item, { headers: httpHeaders });
	}

	setCloseForecast(forecastId: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/success_forecast', forecastId, { headers: httpHeaders });
	}

	historiesForecastChange(forecastId: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/histories_forecast_change', forecastId, { headers: httpHeaders });
	}

	// .. API download template
	downloadTemplateImport(model: string): Observable<Blob> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<Blob>(API_ROOT_IMPORT_AND_TEMPLATE_PO + `/template${model}`, {
			headers: httpHeaders,
			responseType: 'blob' as 'json'
		});
	}

	// .. API import file
	startImportFile(data, model: string): Observable<any> {
		const url = API_ROOT_IMPORT_AND_TEMPLATE_PO + `/import${model}`;
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}

	updateForecastTarget(id: number, target: string, updateId: number, type: number): Observable<any> {
		const url = API_ROOT_URL + `/forecast/${updateId}/${target}`;
		const data = { target: id, referenceId: type };
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}

	fetchForecastByProductIdAndModel(productId: number, model: string): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<ThongTinXacNhanModel>(API_ROOT_URL + `/forecast/${productId}/${model}`, {
			headers: httpHeaders
		});
	}

	exportForecasts(queryParams: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_EXPORT_URL + '/export/forecasts', queryParams, {
			headers: httpHeaders,
		});
	}

	exportForecastsByYearAndQuarter(queryParams: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_EXPORT_URL + '/export/forecasts-by-year-and-quarter', queryParams, {
			headers: httpHeaders,
		});
	}

  updateForForecast(data): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL + '/update-for-forecast', data, { headers: httpHeaders });
	}
}
